define.alias("shared/components/shared/profile-categorization/rewards-steps/report", "media/components/shared/profile-categorization/rewards-steps/report");